import { OrderLineDocumentResponse } from '@ravago/shared/page-data/models/elements';

export async function getOrderLineDocuments(orderId: string, orderNumber: number): Promise<OrderLineDocumentResponse | undefined> {
  const response = await fetch(`/api/orders/${orderId}/order-lines/${orderNumber}/documents`);
  if (!response.ok) {
    return undefined;
  }
  return response.json();
}
